import PdaTitle from '../../component/common/PdaTitle'
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useMountEffect } from 'primereact/hooks'
import { Badge } from 'primereact/badge'
import { useNavigate } from 'react-router-dom'
import { InventorySupplementDetail } from '../../types/inventory'
import { CommonContext } from '../../component/common/context/commonContext'
import { isEmpty, map } from 'lodash'
import { classNames } from 'primereact/utils'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventorySupplement = () => {
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const navigate = useNavigate()

    const [height, setHeight] = useState<number>(0)
    const [list, setList] = useState<InventorySupplementDetail[]>()
    const makeHeight = () => {
        const title = document.getElementsByClassName('pda-title')[0]

        setHeight(window.innerHeight - title.getBoundingClientRect().height)
    }

    useMountEffect(() => {
        console.log('재고 보충 목록')
        makeHeight()
    })

    const findInventorySupplementList = useCallback(() => {
        $http()
            .get('/inventory/supplement')
            .then((result: any) => {
                if (result) {
                    console.log('findInventorySupplementList', result)
                    setList(result.list)
                }
            })
    }, [$http])

    useEffect(() => {
        findInventorySupplementList()
    }, [findInventorySupplementList])

    const onClickScan = (e: InventorySupplementDetail | undefined) => {
        if (e) {
            navigate('/inventory-supplement-scan', {
                state: {
                    detail: e,
                },
            })
        }
    }

    const inventorySupplementTemplate = () => {
        //
        return map(list, (value, index) => {
            //
            return (
                <div
                    key={index + 1}
                    className={classNames('grid w-full p-0 m-0 mb-1 mt-1 border-1 border-round-2xl ', {
                        'bg-white': value.lctScanTyp === 'SRC',
                        'rdms-bg-color-green': value.lctScanTyp === 'DEST',
                    })}
                    style={{ borderColor: '#D3D3D3' }}
                    onClick={() => onClickScan(value)}
                >
                    <div className="col-fixed flex align-items-center justify-content-center font-bold p-0" style={{ width: '40px' }}>
                        <Badge className="bg-color-yellow" value={index + 1} />
                    </div>
                    <div className="col flex flex-column p-0">
                        <div className="col-12 flex align-items-center justify-content-start p-0 pb-2 pt-2">
                            <div className="text-color-blue font-bold" style={{ width: '50px' }}>
                                {t(tokens.common.product_name)} :
                            </div>
                            <div className="font-semibold text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {`${value.goodsNm}`}
                            </div>
                            <div className="text-color-blue font-bold" style={{ marginLeft: '50px' }}>
                                {t(tokens.common.product_barcode)} :
                            </div>
                            <div className="font-semibold text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {`${value.sysCd}`}
                            </div>
                        </div>
                        <div className="col-12 flex align-items-center justify-content p-0 pb-2 pb-2">
                            <div className="text-color-blue font-bold">{t(tokens.common.departure)} :</div>
                            <div className="font-semibold text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {`${value.srcSectorNm + '' + value.srcBayId?.substring(1)}-${value.srcRackRowId?.padStart(
                                    2,
                                    '0',
                                )}-${value.srcRackColId?.padStart(2, '0')}`}
                            </div>
                        </div>
                        <div className="col-12 flex align-items-center justify-content-start p-0 pb-2 pb-2">
                            <div className="text-color-blue font-bold">
                                {t(tokens.common.expiration_date)} / {t(tokens.common.lot_no)} :
                            </div>
                            <div className="font-semibold text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {`${value.shlfYmd}`} / {`${value.lotNo}`}
                            </div>
                        </div>
                        <div className="col-12 flex align-items-center justify-content-start p-0 pb-2 pb-2">
                            <div className="text-color-blue font-bold" style={{ width: '36px' }}>
                                {t(tokens.common.arrival)} :
                            </div>
                            <div className="font-semibold text-left text-overflow-ellipsis overflow-hidden white-space-nowrap">
                                {`${value.destSectorNm + '' + value.destBayId?.substring(1)}-${value.destRackRowId?.padStart(
                                    2,
                                    '0',
                                )}-${value.destRackColId?.padStart(2, '0')}`}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    }

    return (
        <div>
            <PdaTitle title={t(tokens.common.inventory_replenishment_list)} historyBack goToHome />
            <div className="mt-1 overflow-y-scroll p-3 pt-1" style={{ height }}>
                {isEmpty(list) ? <div>{t(tokens.inventory.empty_inventory_supplement_list)}</div> : inventorySupplementTemplate()}
            </div>
        </div>
    )
}

export default InventorySupplement
